module.exports = __webpack_public_path__ + "static/media/stats_background.57313c32.svg";